import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=02ac0411&scoped=true&"
var script = {}
import style0 from "./nothing.vue?vue&type=style&index=0&id=02ac0411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ac0411",
  null
  
)

export default component.exports